export default {"src":"/_next/static/media/add-circle-fill.15e61052.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};